import React, { useState, useEffect, Fragment } from 'react'
import { Block, Card, Grid, Filter, Button } from '@components'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

const FilteredList = ({
  items = [],
  filters = [],
  defaultQueries = new Map([]),
  location
}) => {
  const [queries, setQueries] = useState(defaultQueries)
  const [filteredItems, setFilteredItems] = useState([...items])
  const [visibleItems, setVisibleItems] = useState(17)

  const handleLoadMore = () =>
    setVisibleItems(prevVisibleItems => prevVisibleItems + 18)

  const selectRef = React.createRef()

  const onCategoryClick = e => {
    e.persist()
    e.preventDefault()

    selectRef.current.value = e.target.innerText
      .trim()
      .toLowerCase()
      .replace(/ /gi, '-')

    updateQueries({
      target: {
        value: selectRef.current.value,
        name: 'categories'
      }
    })
  }

  const filterItems = allItems => {
    return allItems.filter(item => {
      if (queries.size < 1) return true

      const filterFields = [...queries.keys()]

      for (let i = 0; i < filterFields.length; i++) {
        const type = filterFields[i]
        const itemValue = item[type]

        // If no value has been selected or default value has been selected
        if (!queries.has(type) || queries.get(type) === '') {
          continue
        }

        if (!itemValue) return false

        // If value check item
        const value = queries.get(type)

        // Value can be an array, test all values
        if (Array.isArray(itemValue)) {
          if (itemValue.find(({ slug }) => slug === value) === undefined)
            return false
        } else if (itemValue.slug && itemValue.slug !== value) {
          return false
        } else if (!itemValue.slug && itemValue !== value) {
          return false
        }
      }

      return true
    })
  }

  const filterContent = () => {
    const filteredList = filterItems(items)

    const configuredList = filteredList.map((item, i) => {
      const imgSrcArr = [item.image.fluid]

      if (i === 0)
        imgSrcArr.push({
          ...item.wideImage.fluid,
          media: `(min-width: 1024px)`
        })

      return {
        ...item,
        image: {
          fluid: imgSrcArr
        }
      }
    })
    setFilteredItems(configuredList)
  }

  const updateQueries = ({ target }) => {
    const newQuery = new Map(queries)

    newQuery.set(target.name, target.value)
    setQueries(newQuery)
  }

  useEffect(() => {
    if (!queries) return

    filterContent()
  }, [queries])

  return (
    <Fragment>
      {filters.length > 0 && (
        <form>
          <Filter
            onChange={updateQueries}
            filters={filters}
            location={location}
            ref={selectRef}
          />
        </form>
      )}
      {filteredItems.length > 0 ? (
        <Block padding={filters.length > 0 ? 'top' : 'None'}>
          <Grid gridGap="slim">
            {filteredItems.slice(0, visibleItems).map(item => (
              <Card
                key={`card--${item.id}`}
                {...item}
                elevated
                onClick={e => onCategoryClick(e)}
              />
            ))}
          </Grid>
        </Block>
      ) : (
        <Block padding="both">
          <center>
            {`Sorry, we can't find an exact match for your search. Please try
            again.`}
          </center>
        </Block>
      )}
      {filteredItems.length > visibleItems && (
        <Block gutters padding="bottom" centreChildren>
          <Button
            type="button"
            onClick={handleLoadMore}
            children="Load More"
            fullWidthMobile
            block
            short
          />
        </Block>
      )}
    </Fragment>
  )
}

export default FilteredList

FilteredList.propTypes = {
  items: PropTypes.array.isRequired,
  defaultQueries: PropTypes.object.isRequired
}

export const query = graphql`
  fragment FilteredBlogList on DatoCmsFilteredBlogList {
    padding
    background
    id
    model {
      apiKey
    }
  }
`
